import type { ReactNode } from 'react';

import { FileTextOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import type { EParticipantsImportStatus } from '@/api/endpoints/schools/schoolParticipants';
import { DATE_FORMATTERS } from '@/shared/consts';

import { IMPORT_STATUS_TO_TAG_SETTINGS } from './consts';
import styles from './ImportInfo.module.scss';

interface IProp {
  importStatus: EParticipantsImportStatus;
  date: string;
  participantsCount: number;
  importedParticipantsCount: number;
  errorParticipantsCount: number;
  filename: string;
}

export const ImportInfo = ({
  importStatus,
  date,
  participantsCount,
  importedParticipantsCount,
  errorParticipantsCount,
  filename,
}: IProp) => {
  const { text: tagText, color: tagColor, icon: tagIcon } = IMPORT_STATUS_TO_TAG_SETTINGS[importStatus];

  return (
    <div className={styles.wrapper}>
      <FileTextOutlined className={styles['info-icon']} />
      <div className={styles['info-wrapper']}>
        <div className={styles['header-wrapper']}>
          <p className={styles.filename}>{filename}</p>
          <Tag
            color={tagColor}
            icon={tagIcon as ReactNode}
          >
            {tagText}
          </Tag>
        </div>
        <div className={styles['info-values-wrapper']}>
          <p className={styles['info-value']}>
            {format(date, DATE_FORMATTERS.DAY_FULL_MONTH_FULL_YEAR_HOURS_MINUTES, { locale: ru })}
          </p>
          <p className={styles['info-value']}>Всего: {participantsCount}</p>
          <p className={styles['info-value']}>Успешно: {importedParticipantsCount}</p>{' '}
          <p className={styles['info-value']}>Ошибок: {errorParticipantsCount}</p>
        </div>
      </div>
    </div>
  );
};
